export { loadPluralMapping } from './loads';
export { driverPluralMapping } from './drivers';
export { milePluralMapping } from './miles';
export { quotePluralMapping } from './quotes';
